import {
    CREATE_SNOWFLAKE_CONNECTION_FAILURE,
    CREATE_SNOWFLAKE_CONNECTION_SUCCESS,
    DELETE_SNOWFLAKE_CONNECTION_FAILURE,
    DELETE_SNOWFLAKE_CONNECTION_SUCCESS,
    GET_SNOWFLAKE_CONNECTION_FAILURE,
    GET_SNOWFLAKE_CONNECTION_SUCCESS,
    GET_SNOWFLAKE_CONNECTIONS_FAILURE,
    GET_SNOWFLAKE_CONNECTIONS_SUCCESS,
    GET_SNOWFLAKE_CONNECTION_TABLES_FAILURE,
    GET_SNOWFLAKE_CONNECTION_TABLES_SUCCESS,
    GET_SNOWFLAKE_TABLE_PREVIEW_FAILURE,
    GET_SNOWFLAKE_TABLE_PREVIEW_SUCCESS,
    GET_SNOWFLAKE_TABLE_SCHEMA_FAILURE,
    GET_SNOWFLAKE_TABLE_SCHEMA_SUCCESS,
    UPDATE_SNOWFLAKE_CONNECTION_FAILURE,
    UPDATE_SNOWFLAKE_CONNECTION_SUCCESS,
} from "./actions";

const initialState = {
    getConnectionsResult: {
        success: true,
    },
    connectionListResult: {
        Items: [],
    },
    createConnectionResult: {
        success: true,
    },
    createdConnection: null,
    getConnectionResult: {
        success: true,
    },
    connection: null,
    updateConnectionResult: {
        success: true,
    },
    deleteConnectionResult: {
        success: true,
    },
    getSnowflakeConnectionTablesResult: {
        success: true,
    },
    snowflakeConnectionTables: [],
    getSnowflakeTablePreviewResult: {
        success: true,
    },
    snowflakeTablePreview: [],
    getSnowflakeTableSchemaResult: {
        success: true,
    },
    snowflakeTableSchema: [],
};

export default (state = initialState, action) => {
    let connectionListResult = {
        Items: [],
    };
    let connectionIndex = -1;
    switch (action.type) {
        case GET_SNOWFLAKE_CONNECTIONS_SUCCESS:
            return { ...state, getConnectionsResult: { success: true }, connectionListResult: action.payload.result };
        case GET_SNOWFLAKE_CONNECTIONS_FAILURE:
            return { ...state, getConnectionsResult: { success: false, ...action.payload.error }, connectionListResult: { Items: [] } };
        case CREATE_SNOWFLAKE_CONNECTION_SUCCESS:
            return { ...state, createConnectionResult: { success: true }, createdConnection: action.payload.connection };
        case CREATE_SNOWFLAKE_CONNECTION_FAILURE:
            return { ...state, createConnectionResult: { success: false, ...action.payload.error }, createdConnection: null };
        case GET_SNOWFLAKE_CONNECTION_SUCCESS:
            return { ...state, getConnectionResult: { success: true }, connection: action.payload.connection };
        case GET_SNOWFLAKE_CONNECTION_FAILURE:
            return { ...state, getConnectionResult: { success: false, ...action.payload.error }, connection: null };
        case UPDATE_SNOWFLAKE_CONNECTION_SUCCESS:
            connectionListResult = state.connectionListResult;
            if (action.payload.connection) {
                connectionIndex = connectionListResult.Items.findIndex((item) => item.connectionId === action.payload.connection.connectionId);
                if (connectionIndex > -1) {
                    connectionListResult = { ...connectionListResult };
                    connectionListResult.Items = [...connectionListResult.Items];
                    connectionListResult.Items[connectionIndex] = action.payload.connection;
                }
            }
            return { ...state, updateConnectionResult: { success: true }, connectionListResult };
        case UPDATE_SNOWFLAKE_CONNECTION_FAILURE:
            return { ...state, updateConnectionResult: { success: false, ...action.payload.error } };
        case DELETE_SNOWFLAKE_CONNECTION_SUCCESS:
            connectionListResult = { ...state.connectionListResult };
            connectionListResult.Items = state.connectionListResult.Items.filter((item) => item.connectionId !== action.payload.connectionId);
            return { ...state, deleteConnectionResult: { success: true }, connectionListResult };
        case DELETE_SNOWFLAKE_CONNECTION_FAILURE:
            return { ...state, deleteConnectionResult: { success: false, ...action.payload.error } };
        case GET_SNOWFLAKE_CONNECTION_TABLES_SUCCESS:
            return { ...state, getSnowflakeConnectionTablesResult: { success: true }, snowflakeConnectionTables: action.payload.result };
        case GET_SNOWFLAKE_CONNECTION_TABLES_FAILURE:
            return { ...state, getSnowflakeConnectionTablesResult: { success: false, ...action.payload.error }, snowflakeConnectionTables: [] };
        case GET_SNOWFLAKE_TABLE_PREVIEW_SUCCESS:
            return {
                ...state,
                getSnowflakeTablePreviewResult: { success: true },
                snowflakeTablePreview: action.payload.data,
            };
        case GET_SNOWFLAKE_TABLE_PREVIEW_FAILURE:
            return {
                ...state,
                getSnowflakeTablePreviewResult: { success: false, ...action.payload.error },
                snowflakeTablePreview: [],
            };
        case GET_SNOWFLAKE_TABLE_SCHEMA_SUCCESS:
            return {
                ...state,
                getSnowflakeTableSchemaResult: { success: true },
                snowflakeTableSchema: action.payload.schema,
            };
        case GET_SNOWFLAKE_TABLE_SCHEMA_FAILURE:
            return {
                ...state,
                getSnowflakeTableSchemaResult: { success: false, ...action.payload.error },
                snowflakeTableSchema: [],
            };
        default:
            return state;
    }
};